import type { PitchDistance, PitchPosition } from './types'

type PositionPath = {
  distance: PitchDistance
  position: PitchPosition
  d: string
  stroke?: string
  strokeWidth?: number
  strokeDashArray?: `${number} ${number}`
  baseFillClass?: string
}

export const positionPaths: PositionPath[] = [
  {
    distance: '9m',
    position: 'left',
    d: 'M190.5 171L207.5 64.5C207.5 64.5 160.5 63.5 126.5 53.5C89.5 42.6176 63.5 20 63.5 20L1.5 171H190.5Z',
  },
  {
    distance: '6m',
    position: 'left',
    d: 'M173 37C156.5 32.5677 145 27.5 145 27.5L116 50C116 50 129.5 56.2143 156 60C182.5 63.7857 207.5 64.5 207.5 64.5L210.5 43C210.5 43 189.752 41.5 173 37Z',
    stroke: 'rgba(156,178,201,1)',
    strokeWidth: 2,
    strokeDashArray: '4 4',
    baseFillClass: 'fill-[rgba(225,232,239,1)]',
  },
  {
    distance: '6m',
    position: 'left-wing',
    d: 'M71 1L63 20C63 20 73 28 84.5 35C97.7186 43.0461 116 50.5 116 50.5L145 27.5C145 27.5 133.425 22.0618 128.5 16C122 8 123.5 1 123.5 1H71Z',
    stroke: 'rgba(156,178,201,1)',
    strokeWidth: 2,
    strokeDashArray: '4 4',
  },
  {
    distance: '9m',
    position: 'right',
    d: 'M378.5 171L362.5 64.5C362.5 64.5 409.5 63.5 443.5 53.5C480.5 42.6176 505 19.5 505 19.5L566.5 171H378.5Z',
  },
  {
    distance: '6m',
    position: 'right',
    d: 'M397 37C413.5 32.5677 425 27.5 425 27.5L454 50C454 50 440 55.7674 414 60C388 64.2326 362.5 64.5 362.5 64.5L360 43C360 43 380.248 41.5 397 37Z',
    baseFillClass: 'fill-[rgba(225,232,239,1)]',
  },
  {
    distance: '6m',
    position: 'right-wing',
    d: 'M497.5 1L505 20C505 20 494.031 28.9909 485.5 34.5C472 43.2176 454 50 454 50L425 27.5C425 27.5 436.575 22.0618 441.5 16C448 8 446.5 1 446.5 1H497.5Z',
    stroke: 'rgba(156,178,201,1)',
    strokeWidth: 2,
    strokeDashArray: '4 4',
    baseFillClass: 'fill-[rgba(196,209,222,1)]',
  },
  {
    distance: '6m',
    position: 'center',
    d: 'M283.5 45C254.986 44.9732 210.5 43 210.5 43L207.5 64.5C207.5 64.5 239 68 277 68C355 68 362.5 64.5 362.5 64.5L360 43C360 43 313.381 45.0281 283.5 45Z',
    stroke: 'rgba(156,178,201,1)',
    strokeWidth: 2,
    strokeDashArray: '4 4',
    baseFillClass: 'fill-[rgba(206,217,228,1)]',
  },
  {
    distance: '9m',
    position: 'center',
    d: 'M379 171H190.5L207.5 64.5C207.5 64.5 251.976 66.8111 280.5 67C312.532 67.2121 362.5 64.5 362.5 64.5L379 171Z',
    stroke: 'rgba(156,178,201,1)',
    strokeWidth: 2,
    strokeDashArray: '4 4',
    baseFillClass: 'fill-[rgba(216,224,233,1)]',
  },
]
